export default "__VITE_ASSET__DyT$f$0i__"